import { render, staticRenderFns } from "./SetCompany.vue?vue&type=template&id=1ca86e3c"
import script from "./SetCompany.vue?vue&type=script&lang=js"
export * from "./SetCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports